import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar             from "./components/Navbar";
import HomePage           from "./pages/HomePage";
import LoginPage          from "./pages/LoginPage";
import RegisterPage       from "./pages/RegisterPage";
import CoachPage          from "./pages/CoachPage";
import BookingPage        from "./pages/BookingPage";
import BookingsPage       from "./pages/BookingsPage";
import VerifyPendingPage  from "./pages/VerifyPendingPage";
import VerifyEmailPage    from "./pages/VerifyEmailPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import CoachDashboard     from "./pages/CoachDashboard";
import AdminDashboard     from "./pages/AdminDashboard";
import "./index.css";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" replace />;
}

function AppLayout() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/"                element={<HomePage />} />
        <Route path="/login"           element={<LoginPage />} />
        <Route path="/register"        element={<RegisterPage />} />
        <Route path="/verify-pending"  element={<VerifyPendingPage />} />
        <Route path="/verify-email"    element={<VerifyEmailPage />} />
        <Route path="/coaches/:id"     element={<CoachPage />} />
        <Route path="/booking"         element={<PrivateRoute><BookingPage /></PrivateRoute>} />
        <Route path="/booking/success" element={<BookingSuccessPage />} />
        <Route path="/bookings"        element={<PrivateRoute><BookingsPage /></PrivateRoute>} />
        <Route path="/coach/dashboard" element={<PrivateRoute><CoachDashboard /></PrivateRoute>} />
        <Route path="/admin/dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
        <Route path="*"                element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppLayout />
      </AuthProvider>
    </BrowserRouter>
  );
}